import { nanoid } from 'nanoid';
import { IQuestionAnswer } from '../form-root/contracts';
export function prefillEntityInfo(formLayout: string, firstName?: string, lastName?: string, email?: string): IQuestionAnswer[] | undefined {
	if (!formLayout) return undefined;

	let prefilledAnswers: IQuestionAnswer[] | undefined;

	const userInfo: Record<string, string> = {};
	if (firstName) userInfo.firstName = firstName;
	if (lastName) userInfo.lastName = lastName;
	if (email) userInfo.email = email;

	const layout = JSON.parse(formLayout);
	const createPersonBlock = layout?.layouts[0]?.props?.sections[0]?.fields?.find(field => field.type === 'CreatePerson');

	if (createPersonBlock) {
		const answer = { contacts: [{ id: nanoid(), ...userInfo }] };

		prefilledAnswers = [
			{
				questionName: createPersonBlock.name,
				answer: {
					answerJson: JSON.stringify(answer)
				},
				type: createPersonBlock.type
			}
		];
	}
	return prefilledAnswers;
}
